import { i18n } from 'i18n';

export const CATEGORIES: { [key: string]: string } = {
	announcements: i18n.t('Анонсы'),
	discounts: i18n.t('Скидки'),
	entertainments: i18n.t('Развлечения'),
	gadgets_and_devices: i18n.t('Гаджеты и устройства'),
	games: i18n.t('Игры'),
	technologies: i18n.t('Технологии'),
};
